export default __webpack_public_path__ + "static/media/nextjs.e3c042b9.svg";